import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'recherche1'
})
export class Recherche1Pipe implements PipeTransform {

  transform(value: any, term: any): any {
    if (term == null) {
      return value;
    } else {
      const lowercaseTerm = term.toLowerCase();
      const uppercaseTerm = term.toUpperCase();
      return value.filter((item: any) => {
        const lowercaseNomEntreprise = item.name.toLowerCase();
        const uppercaseNomEntreprise = item.name.toUpperCase();
        return lowercaseNomEntreprise.includes(lowercaseTerm) || uppercaseNomEntreprise.includes(uppercaseTerm);
      });
    }
  }


}
